import TopLevelState from './TopLevelState'
import {wrap} from './reducer'
export default wrap(TopLevelState)
